import { connect } from 'react-redux';
import FeedbackForm from './components/FeedbackForm';
import {
    submitFFForm,
    updateValue,
    updateFormStatus,
    resetFormAction
} from './actions/feedbackFormActions';

export const mapStateToProps = state => ({
    fields: state.feedbackForm.fields,
    formSubmitInProgress: state.feedbackForm.formSubmitInProgress,
    formFailed: state.feedbackForm.formFailed,
    formSubmitted: state.feedbackForm.formSubmitted,
    message: state.feedbackForm.message
});

export const mapActionCreators = {
    submitFFForm,
    updateValue,
    updateFormStatus,
    resetFormAction
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(FeedbackForm);
